var drop = require('./drop');

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @alias tail
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.rest([1, 2, 3]);
 * // => [2, 3]
 */
function rest(array) {
  return drop(array, 1);
}

module.exports = rest;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tel-input/~/lodash/array/rest.js
 ** module id = 1182
 ** module chunks = 0
 **/